module.exports = __webpack_public_path__ + "img/visa.eb0d7d6c.png";